import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'

export const NotesDetails = ({notes}: {notes: string | null}) => {
    const {t} = useTranslation()
    if (!notes)
        return (
            <Text size="textSm" palette="neutral" shade="500">
                {t('commons:no_note')}
            </Text>
        )

    return (
        <Text size="textSm" palette="neutral" shade="500">
            {notes}
        </Text>
    )
}
